import { getDiffItemsStr } from "@checkout-core/helpers/GroupCart";
import { GetGroupCartOrderResponse, GroupOrderError, GroupOrderState } from "@swiggy-private/cart-types";

export enum GroupCartActionTypes {
    GROUP_CART_STATE_FETCH_IN_PROGRESS,
    GROUP_CART_STATE_UPDATE_IN_PROGRESS,
    UPDATE_GROUP_CART_STATE,
}

export type GroupCartAction =
    | {
          type: GroupCartActionTypes.UPDATE_GROUP_CART_STATE;
          payload: {
              data?: GetGroupCartOrderResponse["data"];
              getSharedCartLoading?: boolean;
              updateSharedCartLoading?: boolean;
              error?: GroupOrderError;
              softError?: string;
              isCartLocked?: boolean;
          };
      }
    | { type: GroupCartActionTypes.GROUP_CART_STATE_FETCH_IN_PROGRESS; payload?: null }
    | { type: GroupCartActionTypes.GROUP_CART_STATE_UPDATE_IN_PROGRESS; payload?: null };

export function GroupCartReducer(state: GroupOrderState, action: GroupCartAction): GroupOrderState {
    const { type, payload } = action || {};

    switch (type) {
        case GroupCartActionTypes.GROUP_CART_STATE_FETCH_IN_PROGRESS:
            return {
                ...state,
                getSharedCartLoading: true,
            };

        case GroupCartActionTypes.GROUP_CART_STATE_UPDATE_IN_PROGRESS:
            return {
                ...state,
                updateSharedCartLoading: true,
            };

        case GroupCartActionTypes.UPDATE_GROUP_CART_STATE: {
            const _diffItemsStr = getDiffItemsStr(state.data, payload?.data);
            return {
                ...state,
                ...payload,
                getSharedCartLoading: false,
                updateSharedCartLoading: false,
                diffString: _diffItemsStr,
            };
        }

        default:
            throw new Error(`unhandled action type ${type}`);
    }
}
